import { Component } from "react";
import PropTypes from "prop-types"
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd'
import {ToggleButton} from "react-bootstrap"
import ButtonGroup from "react-bootstrap/ButtonGroup"

const initialData = {
  filters: {},
  columns: {
    manage: {
      id: "manage",
      title: "Manage columns",
      filterIds: []
    }
  },
  columnOrder: ['manage']
}

export default class ManageColumn extends Component {
  constructor(props) {
    super(props)

    this.state = initialData
  }

  componentDidMount() {
    this.props.columns.forEach((column) => {
      initialData.filters[column.dataField] = {
        id: column.dataField,
        content: column.text
      }
      initialData.columns.manage.filterIds.push(column.dataField)
    })

    this.setState({initialData})
  }

  onDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const home = this.state.columns[source.droppableId];
    const foreign = this.state.columns[destination.droppableId];

    if (home === foreign) {
      const newFilterIds = Array.from(home.filterIds);
      newFilterIds.splice(source.index, 1);
      newFilterIds.splice(destination.index, 0, draggableId);

      const newHome = {
        ...home,
        filterIds: newFilterIds,
      };

      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [newHome.id]: newHome,
        },
      };

      this.setState(newState, () => {
        this.props.handleOrder(this.state.columns.manage.filterIds)
      });
    }
  }

  _showHideColumn = (column) => {
    const { onColumnToggle, toggles, handleDisplay } = this.props
    handleDisplay(column, toggles[column], () => {
      onColumnToggle(column)
    })
  }

  render(){
    const { toggles } = this.props
    return(
      <DragDropContext onDragEnd={this.onDragEnd}>
        {
          this.state.columnOrder.map(columnId => {
            const column = this.state.columns[columnId];
            const filters = column.filterIds.map(
              filterId => this.state.filters[filterId],
            );

            return <div key={`${columnId}-${column.id}`}>
              <Droppable droppableId={column.id} direction="horizontal">
                {(provided, snapshot) => (
                  <div
                    className={`list-group list-group-horizontal`}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {filters.map((filter, index) => (
                      <Draggable draggableId={filter.id} index={index} key={filter.id}>
                        {(provided, snapshot) => (
                          <div
                            className={`${snapshot.isDragging ? `font-weight-bold mb-2` : `mb-2`} list-group-item p-2`}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                            <div className="d-flex align-items-center">
                              <i className="fas fa-grip-vertical" style={{fontSize: '0.8rem', color: 'rgb(179 179 179)'}}></i>
                              <ButtonGroup toggle className="ml-1">
                                <ToggleButton
                                  type="checkbox"
                                  variant={`${toggles[filter.id] ? 'primary' : 'secondary'}`}
                                  checked={toggles[filter.id]}
                                  value="1"
                                  style={{padding: '2px', fontSize: '0.8rem', minWidth: '60px'}}
                                  onChange={(e) => this._showHideColumn(filter.id)}
                                >
                                  { filter.content }
                                </ToggleButton>
                              </ButtonGroup>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

            </div>
          })
        }
      </DragDropContext>
    )
  }
}

ManageColumn.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  onColumnToggle: PropTypes.func.isRequired,
  toggles: PropTypes.object.isRequired
}
